import useScreenSize from "../hooks/useScreenSize";

export default function SiteHeader() {
	const screenSizes = useScreenSize();

	return (
		<div
			style={{
				margin: 0,
				padding: 0
			}}
		>
			{!screenSizes.isLarge && (
				<>
					<img
						style={{
							width: "100%",
							display: "block",
							margin: 0
						}}
						src="https://s3.kftus.com/kft-cms/web_mobile_e49ae53611.webp"
					></img>
					<a href="https://www.kungfutea.com">
						<img
							src="https://s3.kftus.com/kft-cms/website_logo_copy_89b8187adb.webp"
							style={{
								position: "absolute",
								top: "0px",
								right: "0px",
								width: "32vw"
							}}
						></img>
					</a>
				</>
			)}

			{screenSizes.isLarge && (
				<>
					<img
						style={{
							width: "100%",
							display: "block",
							margin: 0
						}}
						src="https://s3.kftus.com/kft-cms/website_51e58e1aa2.webp"
					></img>
					<a href="https://www.kungfutea.com">
						<img
							src="https://s3.kftus.com/kft-cms/website_logo_9da16be86b.webp"
							style={{
								position: "absolute",
								top: "0px",
								left: "0px",
								width: "18vw"
							}}
						></img>
					</a>
				</>
			)}
		</div>
	);
}
